<div class="fo-container">
  <mat-card class="fo-card">
    <div class="fo-card-content">
      <div *ngIf="loading">
        <mat-icon class="fo-icon">sync</mat-icon>
        <p class="fo-description">Completing connection...</p>
      </div>

      <div *ngIf="error">
        <mat-icon class="fo-icon error">error_outline</mat-icon>
        <h2>Connection Failed</h2>
        <p class="fo-error">{{ error }}</p>
        <button mat-raised-button color="primary" class="fo-button" routerLink="/field-ops/connect">Try Again</button>
      </div>
    </div>
  </mat-card>
</div>
